import { render, staticRenderFns } from "./leaveUntreatedOrderList.vue?vue&type=template&id=74c79a83&"
import script from "./leaveUntreatedOrderList.vue?vue&type=script&lang=js&"
export * from "./leaveUntreatedOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports